import React from "react";
import {
  AutocompleteInput,
  Create,
  ReferenceInput,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
} from "react-admin";
// Local

const EditToolbar = props => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

const PaveCredCreate = props => (
  <Create {...props}>
    <SimpleForm redirect="list" toolbar={<EditToolbar />}>
      <ReferenceInput source="dealerId" reference="dealers" autoFocus fullWidth>
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <TextInput source="apiUser" fullWidth isRequired />
      <TextInput source="apiKey" fullWidth isRequired />
      <TextInput source="apiSecret" fullWidth isRequired />
    </SimpleForm>
  </Create>
);

export default PaveCredCreate;
